
import * as R from 'ramda';
import moment from 'moment-timezone';
import { takeLatest, select, put, delay } from 'redux-saga/effects';
import { account as accountApis } from '../../../../api.js';
import { apiSaga } from '../../../../root-sagas';
import docCookie from '../../../../utils/docCookie';

function* doSignUp({ type }) {
  const store = yield select(state => state.BookingsAISignUp);
  const payload = R.pick(['email',
  'password',
  'firstName',
  'lastName',
  'companyName',
  'dateFormat',
  'affiliates',
  'dashboardUrl',
  'bookingSystem',
  'emailClient',
  'companyId',
  'userId',
  'shouldSend3rdPartyEmail'], store);
  let referral;
  if (docCookie.getItem('rewardful.referral')) {
    try {
      const referralObj = JSON.parse(docCookie.getItem('rewardful.referral'));
      referral = referralObj.id;
    } catch (err) {
      // Silently fail - referral is optional
      if (process.env.NODE_ENV === 'development') {
        console.log('error in parsing referral cookie', err);
      }
    }
  }
  yield apiSaga(type, accountApis.signUpBookingAiUser, [{
    ...payload,
    referral,
    region: moment.tz.guess(),
  }]);
}

function* doEmailCheck({ type }) {
  const { email } = yield select(state => state.BookingsAISignUp);
  yield apiSaga(type, accountApis.decryptEmail, [{ email }]);
}

function* signUpSuccess(action) {
  const state = yield select(state => state.BookingsAISignUp);
  const { autoLoginLink } = state;
  
  if (autoLoginLink) {
    // Verify the autoLoginLink includes the correct route and required parameters
    const hasCorrectRoute = autoLoginLink.includes('/generative-ai/addin-installation');
    const hasHashToken = autoLoginLink.includes('hashToken=');
    
    // Log warnings in development only
    if (process.env.NODE_ENV === 'development') {
      if (!hasCorrectRoute) {
        console.warn('WARNING: autoLoginLink does not include /generative-ai/addin-installation route');
      }
      if (!hasHashToken) {
        console.warn('WARNING: autoLoginLink does not include hashToken query parameter');
      }
    }
    
    // Check if autoLoginLink contains JWT (required to avoid sign-in redirect)
    let hasJWT = false;
    try {
      const urlObj = new URL(autoLoginLink);
      // URL.searchParams.get automatically decodes URL-encoded values
      const jwtInUrl = urlObj.searchParams.get('jwt');
      hasJWT = Boolean(jwtInUrl);
      
      if (!hasJWT && !localStorage.getItem('jwt')) {
        // Log error if no JWT found (user will be redirected to sign-in)
        if (window.Rollbar) {
          window.Rollbar.warning('No JWT found in autoLoginLink or localStorage', {
            autoLoginLink: autoLoginLink.substring(0, 100) // Log first 100 chars only
          });
        }
      }
    } catch (e) {
      // If URL parsing fails, try manual regex check
      const jwtMatch = autoLoginLink.match(/[?&]jwt=([^&]*)/);
      hasJWT = Boolean(jwtMatch && jwtMatch[1]);
      
      if (window.Rollbar) {
        window.Rollbar.warning('Could not parse autoLoginLink as URL', {
          error: e.message,
          autoLoginLink: autoLoginLink.substring(0, 100)
        });
      }
    }
    
    yield put({
      type: 'bookingsAISignUp_successMessage',
      payload: 'One moment please, we are logging you in right now...'
    });
    yield delay(4000);
    
    // The autoLoginLink should include the route to generative-ai/addin-installation
    // When the user lands on that route, the generative-ai location change handler will catch it
    // queryString.parse in the handler will automatically decode URL-encoded parameters
    window.location.assign(autoLoginLink);
  } else {
    yield put({
      type: 'bookingsAISignUp_successMessage',
      payload: `We have sent you an email with a link to automatically log in. Please check your inbox.`
    });
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // takeLatest('@@router/LOCATION_CHANGE', checkIfShouldOpenSchedules),
  takeLatest('bookingsAISignUp_doSignUp', doSignUp),
  takeLatest('bookingsAISignUp_doEmailCheck', doEmailCheck),
  takeLatest('bookingsAISignUp_doSignUp_SUCCESS', signUpSuccess),
  takeLatest('bookingsAISignUp_doSignUp_ERROR', function* (action) {
    yield; // Required for generator function
  }),
];
